import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { AppConfigService } from './app/main/app-config.service';

platformBrowserDynamic().bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()], })
  .then(moduleRef => {
    const appConfig = moduleRef.injector.get(AppConfigService);
    if (appConfig.getConfig().production) {
      enableProdMode();
    }
  })
  .catch(err => console.error(err));